class ImageSlider extends Component {
	constructor(el) {
		super(el);
		this.swiperEl = this.$find('[data-slider-images]');
		this.swiperVideos = null;
		this.swiperTitles = null;
		this.swiperEl && this.constructSwiper();
	}

	constructSwiper() {
		this.swiper = new Swiper(this.swiperEl, {
			watchOverflow: true,
			slidesPerView: 1,
			autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.ImageSlider-next',
				prevEl: '.ImageSlider-prev',
			},
		});
	}
}
